import { apiClient } from "./client";

export type ImportEntityType = "clienti" | "sedi" | "interventi";

export interface ImportRowResult {
  row_number: number;
  status: "valida" | "duplicata" | "errore";
  message?: string;
  preview?: Record<string, unknown>;
}

export interface ImportReport {
  entity_type: ImportEntityType;
  colonne_riconosciute: Record<string, string>;
  colonne_non_trovate: string[];
  totale_righe: number;
  righe_valide: number;
  righe_duplicate: number;
  righe_con_errori: number;
  dettaglio: ImportRowResult[];
  creati?: number;
}

export async function previewImport(entityType: ImportEntityType, file: File): Promise<ImportReport> {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await apiClient.post<ImportReport>(`/import/${entityType}/preview`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function commitImport(entityType: ImportEntityType, file: File): Promise<ImportReport> {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await apiClient.post<ImportReport>(`/import/${entityType}/commit`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function downloadTemplate(entityType: ImportEntityType): Promise<void> {
  const response = await apiClient.get(`/import/${entityType}/template`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `template-${entityType}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
